import React from "react";

const PdfText = (props) => {
    return(<>
        <h1 className="font-bold text-base pb-5">{props.title}</h1>
      <p className="font-normal text-base pb-5">{props.subtitle}</p>
        </>)
}

export default PdfText;